<template>
  <v-container fluid>
    <PageHeader title="Manage Guidelines" icon="assignment" :subtitle="subtitle" />
    <Subheader v-model="search" title="Guidelines" search="guidelines">
      <v-btn dark color="add" :to="{name: 'guidelinesDetail', params: {name: AddGuidelineActionName}}">
        <v-icon>add</v-icon>{{$t('Button.AddaNewGuideline')}}
      </v-btn>
    </Subheader>
    <v-card>
      <v-card-text>
        <v-data-table :headers="headers" :items="GuidelineList" :pagination.sync="pagination" :search="search">
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.GuidelineLongName }} ({{props.item.GuidelineName}})</td>
            <td class="text-xs-left">{{ props.item.Category }}</td>
            <td class="text-xs-left">{{ props.item.Medias }}</td>
            <td class="text-xs-left">{{ props.item.LastModifiedDateTime != null ? formatDate(props.item.LastModifiedDateTime, prettyDateTimeFormat) : '' }}</td>
            <td class="text-xs-right" style="display:flex;">
              <v-btn color="warning" :to="{ name: 'guidelinesDetail', params: { name: props.item.GuidelineName }}">
                <v-icon class="mr-1">edit</v-icon>
                {{ $t('Button.Edit') }}
              </v-btn>
              <v-btn color="error" @click="showDeleteGuidelineDialog(props.item)">
                <v-icon class="mr-1">delete_forever</v-icon>
                {{ $t('Button.Delete') }}
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="delDialog" persistent max-width="800">
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-toolbar-title>Delete Guideline</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDeleteGuidelineDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title class="headline">
          {{ $t('GuidelineManagement.deleteTitleMsg', { longName:delGuideline.GuidelineLongName, shortName:delGuideline.GuidelineName }) }}
        </v-card-title>
        <v-card-text>{{ $t('GuidelineManagement.deleteMsg') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="delete" dark @click.native="agreeDelete()">
            <v-icon class="mr-1">delete_forever</v-icon>{{ $t('Button.DELETE_GUIDELINE') }}
          </v-btn>
          <v-btn color="primary" dark @click.native="closeDeleteGuidelineDialog()">{{ $t('Button.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card>
      <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar" auto-height>
        {{ snackMessage }}
        <v-btn dark flat @click.native="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
  import PageHeader from '@/components/generic/PageHeader'
  import Subheader from '@/components/generic/Subheader'
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import { AddGuidelineActionName } from '@/components/mixins/GuidelinesManageUtil'
  const stations = createNamespacedHelpers('stations')
  const guidelines = createNamespacedHelpers('guidelines')
  const admin = createNamespacedHelpers('admin')
  const authenticate = createNamespacedHelpers('authenticate')

  import { prettyDateTimeFormat, formatDate } from '@/components/mixins/MomentUtil'

  export default {
    components: {
      PageHeader,
      Subheader,
    },
    data() {
      return {
        prettyDateTimeFormat,
        tab: 'tab-1',
        search: '',
        headers: [{
          text: 'Name',
          value: 'GuidelineLongName',
          align: 'left',
        },
        {
          text: 'Category',
          value: 'Category',
          align: 'left',
        },
        {
          text: 'Feasible Media Types',
          value: 'Medias',
          align: 'left',
        },
        {
          text: 'Last Modified Date',
          value: 'LastModifiedDateTime',
          align: 'left',
        },
        {
          value: null,
        },
        ],
        pagination: {
          sortBy: 'longName',
          rowsPerPage: 10,
        },
        delDialog: false,
        delGuideline: {},
        snackbar: false,
        snackColor: '',
        snackMessage: '',
        subtitle: 'Use this page to manage system-wide guideline values, metadata, and accessibility.',
      }
    },
    mounted() {
      if (!this.roleList || !this.roleList.length) {
        this.getRoleList()
      }
    },
    computed: {
      ...stations.mapGetters(['mediaTypeList']),
      ...guidelines.mapGetters(['Guidelines']),
      ...admin.mapGetters(['roleList']),
      ...authenticate.mapGetters(['currentUserGroup']),
      tenantList() {
        return JSON.parse(JSON.stringify(this.roleList))
      },
      GuidelineList() {
        var data = JSON.parse(JSON.stringify(this.Guidelines))
        data.forEach(element => {
          element.Medias = element.Medias.map(x => x.Name).join()
          element.LastModifiedDateTime = element.Standards.map(x => x.LastModifiedDateTime).sort((a, b) => (a < b ? 1 : -1))[0]
        })
        return data
      },
      AddGuidelineActionName() {
        return AddGuidelineActionName
      },
    },
    watch: {},
    methods: {
      ...admin.mapActions(['getRoleList']),
      ...guidelines.mapActions(['deleteGuideline']),
      formatDate,
      startSnack(snackColor, snackMessage) {
        this.snackMessage = snackMessage
        this.snackColor = snackColor
        this.snackbar = true
      },
      showDeleteGuidelineDialog(data) {
        this.delGuideline = data
        this.delDialog = true
      },
      closeDeleteGuidelineDialog() {
        this.delGuideline = {}
        this.delDialog = false
      },
      async agreeDelete() {
        let options = {
          data: {
            GuidelineId: this.delGuideline.Id,
          },
          successCb: () => {
            this.startSnack('success', this.$t('GuidelineManagement.successDeleteMsg'))
          },
          failedCb: (err) => {
            this.startSnack('error', err)
          },
        }
        await this.deleteGuideline(options)
        this.closeDeleteGuidelineDialog()
      },

    },
  }
</script>

<style lang="stylus" scoped>
  .toolbar__title.display-2 {
    padding-bottom: 10px;
    margin-left: 10px !important;
  }
</style>